import React, { useContext, useState, useRef, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import Axios from "axios";
import { StateContext } from "../App";
import "./login.css";

function Login(props) {
  const [user, setUser] = useState({});
  const [msg, setMsg] = useState("")
  const [error, setError] = useState("")
  const new_passwordRef = useRef(null);
  const confirm_passwordRef = useRef(null);

  // console.log("Login component!", props);
  const { dispatch } = useContext(StateContext);

  useEffect(() => {
    dispatch({type: 'SET_LOADING', payload: true });
    const key = window.location.href.split("?")[1].split("=")[1];

    Axios.get(`/password-reset?key=${key}`)
      .then(res => {
        dispatch({type: 'SET_LOADING', payload: false });
        console.log(res.data);
        res.data.user && setUser(res.data.user)
        res.data.msg && setMsg(res.data.msg)
    })
    .catch(e => {
      dispatch({type: 'SET_LOADING', payload: false });
    })
  }, [])

  const login_form = async (e) => {
    e.preventDefault();

    if (msg == "") {
      const notLoadingBtn =  document.querySelector(".not-loading-btn")
      const isLoadingBtn = document.querySelector(".btn-back")
      
      notLoadingBtn.style.display = "none";
      isLoadingBtn.style.display = "block";
  
      setError("");
  
      const form = document.querySelector(".login-form");
  
      const password = new_passwordRef.current.value;
        const confirmPassword = confirm_passwordRef.current.value;
        console.log(password, confirmPassword)
  
      if (confirmPassword !== password) {
          isLoadingBtn.style.display = "none";
          notLoadingBtn.style.display = "block";
          setError("Password is not a match.")
      } else {
          const options = {
            id: user._id,
            newPassword: password
  
          }
          Axios.post("/password-reset", options )
          .then(res => { 
            if (res.data.error) {
              isLoadingBtn.style.display = "none";
              notLoadingBtn.style.display = "block";
              setError(res.data.error)
            }
  
            if (res.data.user) {
              localStorage.setItem("user", JSON.stringify(res.data.user._id));
  
              setTimeout(() => {
                if (res.data.user.role === "admin") {
                  props.history.push("/admin-dashboard/customers");
                }
                else {
                  props.history.push("/dashboard/overview");
                }
              }, 1000)
            }
          })
          .catch(e => console.log(e))
      }
    }

   
  };

  return (
    <div className="login">
      <div className="centered">
        <form className="login-form" onSubmit={login_form}>
          {user && <span className="error">{user?.email}</span>}
          <h3>Reset your password</h3>
          {msg && <span className="error">{msg}</span>}
          {error && <span className="error password_reset_error">{error}</span>}
          {/* username OR email */}
          <div className="input-field">
            <input className="email-input" type="text" ref={new_passwordRef} placeholder="Enter your new password" />
          </div>
          {/* Password */}
          <div className="input-field">
            <input
              className="password-input"
              required
              type="password"
              ref={confirm_passwordRef}
              placeholder="Confirm new password"
            />
          </div>
          <div className="input-field">
            <button className="not-loading-btn">login</button>
            <div className="btn-back">
              <button disabled className="loading-btn">
                <div id="loader"></div>
              </button>
            </div>
          </div>
          {/* <div className="action-btn">
            <span>don't have an account?</span>
            <Link to="/signup">signup</Link>
          </div> */}
        </form>
      </div>
      {/* <div className="homepage-link">
        <a href="/">go to homepage</a>
      </div> */}
    </div>
  );
}

export default withRouter(Login);
